import { createContext } from 'react';

export interface OrchestratorAutoflowContextValue {
  loopStepId: string | undefined;
  stepId: string | undefined;
  workflowId: string | undefined;
}

export const OrchestratorAutoflowContext =
  createContext<OrchestratorAutoflowContextValue>({
    loopStepId: undefined,
    stepId: undefined,
    workflowId: undefined,
  });
